// 开发环境
if (process.env.NODE_ENV === "development") {
  window.authBaseUrl =
    "https://finisarinterview.realsun.me/wxauth/oauth?returnUrl=";
  window.returnUrl = "http://localhost:3000/home";
  window.returnRegisterURL = "http://localhost:3000/register";
  window.host = "http://localhost:3000";
  // 生产环境
} else {
  window.authBaseUrl =
    "https://finisarinterview.realsun.me/wxauth/oauth?returnUrl=";
  window.returnUrl = "http://finisarinterview.realsun.me/home";
  window.returnRegisterURL = "http://finisarinterview.realsun.me/register";
  window.host = "http://finisarinterview.realsun.me";
}
